import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useSolicitud } from "@/features/solicitudes/hooks/use-solicitud";
import { useSolicitudPolling } from "@/features/solicitudes/hooks/use-solicitud-polling";
import {
  calcularIntervaloPolling,
  estaEnEsperaDeAutorizacion,
} from "@/features/solicitud-detalle/utils/estado-flags";
import { Route } from "@/routes/_authed-tw/solicitudes/$id/index";
import { DetalleHeader } from "./DetalleHeader";
import { DetalleLayout } from "./DetalleLayout";

export function SolicitudDetallePage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: sol } = useSolicitud(id);
  useSolicitudPolling(id, calcularIntervaloPolling(sol));

  const enEspera = estaEnEsperaDeAutorizacion(sol.estado);
  useEffect(() => {
    if (enEspera) {
      void navigate({
        to: "/solicitudes/$id/autorizacion",
        params: { id },
        replace: true,
      });
    }
  }, [enEspera, id, navigate]);

  if (enEspera) return null;

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <DetalleHeader sol={sol} />
      <DetalleLayout sol={sol} />
    </div>
  );
}
